(function() {
    'use strict';
    angular.module('app').component('habilCollapseAll', {
        templateUrl: '@/collapseAll/collapse-all.html',
        transclude: true,
        bindings: {
            targetSelector: '@',
        },
        controller: CollapseAllController
    });

    function CollapseAllController() {
        const $controller = this;

        $controller.CollapseAll = collapse;
        $controller.ExpandAll = expand;
        

        function collapse() {
            $(`[id^="${$controller.targetSelector}"]`).collapse('hide');
        }

        function expand() {
            $(`[id^="${$controller.targetSelector}"]`).collapse('show');
        }
    }
})();